module.exports = __webpack_public_path__ + "static/img/znhh.0562e39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znhh.png
// module id = Etuc
// module chunks = 0